import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconShareNodes = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.5 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM13 7.5a3.5 3.5 0 1 1 .768 2.188l-2.894 1.38a3.503 3.503 0 0 1-.016 1.92l2.873 1.371a3.5 3.5 0 1 1-.699 1.666l-3.12-1.488a3.5 3.5 0 1 1 .045-5.03l3.084-1.472A3.532 3.532 0 0 1 13 7.5Zm3.5 7.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM6 12a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconShareNodes);
export default Memo;
